<template>
  <EmailEditForm></EmailEditForm>
</template>

<script>
import EmailEditForm from '@/../app/components/commons/EmailEditForm'

export default {
  components: { EmailEditForm }
}
</script>
